import React, { useState, useEffect } from "react";
import { Row, Col, Card, Typography, message, Divider, Table, Input, Space, Select, Tag } from "antd";
import { SearchOutlined, FileDoneOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import http from "../../../services/http";
const { Text } = Typography;

const options_status = [
  { value: 2, label: "Todos" },
  { value: 0, label: "Não Avaliado" },
  { value: 1, label: "Avaliado" },
];

export const AvaliacoesFormulariosColaboradores = () => {
  const { id_avaliacao_formulario, id_avaliacao } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // DADOS
  const [dados, setDados] = useState([]);

  // FILTRO
  const [search, setSearch] = useState("");
  const [filtroStatus, setFiltroStatus] = useState(2);
  // DADOS
  const [avaliacaoFormulario, setAvaliacaoFormulario] = useState({});

  useEffect(() => {
    if (id_avaliacao_formulario) {
      carregarAvaliacaoFormulario(id_avaliacao_formulario);
      listarColaboradoresFormularios(id_avaliacao_formulario);
    }
  }, [id_avaliacao_formulario]);

  // CARREGAR AVALIAÇÃO
  const carregarAvaliacaoFormulario = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/avaliacoes_vinculo_formularios/carregar/${id}`, []);
    if (api.statusCode === 200) {
      setAvaliacaoFormulario(api.response.data);
    } else {
      message.error(api.response.message);
      navigate("/avaliacoes/gestao");
    }
    setLoading(false);
  };

  // LISTAR
  const listarColaboradoresFormularios = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/avaliacoes_formularios_lancamento/listar_pendencias/${id}`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
      navigate("/avaliacoes/gestao");
    }
    setLoading(false);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Nº",
      dataIndex: "id",
      width: 50,
      sorter: (a, b) => a.id?.toString()?.localeCompare(b.id?.toString()),
    },
    {
      title: "Avaliado",
      dataIndex: "avaliado",
      sorter: (a, b) => a.avaliado?.localeCompare(b.avaliado),
    },
    {
      title: "Avaliador",
      dataIndex: "avaliador",
      sorter: (a, b) => a.avaliador?.localeCompare(b.avaliador),
    },
    {
      title: "Situação",
      dataIndex: "status",
      render: (_, e) => (e.status === 1 ? <Tag color="green">Avaliado</Tag> : <Tag color="red">Não Avaliado</Tag>),
      sorter: (a, b) => a.status?.toString()?.localeCompare(b.status?.toString()),
    },
  ];
  // PESQUISAR
  const handleFilter = (pesquisar, filtro_status) => {
    let filteredData = dados?.filter(
      (val) =>
        val.avaliado?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.avaliador?.toLowerCase().includes(pesquisar.toLowerCase())
    );

    switch (filtro_status) {
      case 1:
        filteredData = filteredData.filter((e) => e.status === 1);
        break;
      case 0:
        filteredData = filteredData.filter((e) => e.status === 0);
        break;
      default:
        break;
    }

    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search, filtroStatus) : [];

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage
              title="Avaliações"
              onClickBack={() => navigate(`/avaliacoes/gestao/formularios/${id_avaliacao}`)}
            />
            <HeaderTitle
              title="Avaliações Colaboradores"
              subtitle={
                <Text italic>
                  <FileDoneOutlined /> <Tag>{avaliacaoFormulario?.avaliacao ?? ""}</Tag>
                  {avaliacaoFormulario?.classificacao ?? ""} - {avaliacaoFormulario?.formulario ?? ""}
                </Text>
              }
              icon={<CheckCircleOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space direction="vertical">
                <Space wrap>
                  <Input
                    size="middle"
                    maxLength={100}
                    prefix={<SearchOutlined />}
                    className="input"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Pesquisar..."
                    allowClear
                  />
                  <Select
                    style={{ minWidth: 180 }}
                    value={filtroStatus}
                    onChange={(e) => setFiltroStatus(e)}
                    options={options_status}
                  />
                </Space>
              </Space>

              <Divider />

              <Table
                rowKey="id"
                scroll={{ x: 700 }}
                loading={loading}
                columns={columns}
                dataSource={dadosFilter}
                size="small"
              />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
